<template>
  <div class="video-surveillance-container">
    <div class="corner top-left"></div>
    <div class="corner top-right"></div>
    <div class="corner bottom-left"></div>
    <div class="corner bottom-right"></div>

    <div class="panel-header video-header">
      <span class="panel-title-text">每日自检任务清单</span>
      <div class="title-box">
        <div class="center-top-title"></div>
      </div>
    </div>

    <div class="panel-body">
      <div class="task-module">
        <!-- 左边：任务统计区域 -->
        <div class="left">
      <div class="columns total" data-title="任务统计">
        <div class="echarts-row">
          <div class="echarts-item">
            <Echarts
              v-if="completedPercent != null"
              :percent="completedPercent"
              :num="completedNum"
              type="已完成"
              class="echarts-scale"
            ></Echarts>
          </div>
          <div class="echarts-item">
            <Echarts
              v-if="soon_end_percentage != null"
              :percent="soon_end_percentage"
              :num="soon_end_num"
              type="即将超时"
              class="echarts-scale"
            ></Echarts>
          </div>
        </div>
        <div class="echarts-row">
          <div class="echarts-item">
            <Echarts
              v-if="todpercent != null"
              :percent="todpercent"
              :num="todNum"
              type="待完成"
              class="echarts-scale"
            ></Echarts>
          </div>
          <div class="echarts-item">
            <Echarts
              v-if="overtimePercent != null"
              :percent="overtimePercent"
              :num="overtimeNum"
              type="已超时"
              class="echarts-scale"
            ></Echarts>
          </div>
        </div>
        
            <div v-if="completedPercent == null && soon_end_percentage == null && todpercent == null &&  overtimePercent == null">
              <img
                style="width: 100%;position: absolute;bottom: 30%;"
                src="./../assets/image/NoImg.png"
                alt=""
              />
            </div>
        <div
         v-if="overtimePercent != null"
                style="
                  position: absolute;
                  bottom: 15px;
                  right: 45px;
                  font-weight: bolder;
                  text-align: center;
                  color: rgba(189, 195, 199, 1);
                  font-size: 16px;
                "
              >
                <div>任务总数：{{ total_tasks }}个</div>
              </div>
      </div>
    </div>

    <!-- 右边：上下结构 -->
    <div class="right">
      <!-- 上：已完成任务（轮播图） -->
      <div class="top-right" data-title="已完成任务">
          <div class="completed-carousel">
            <div v-if="!secondContent.length > 0">
              <img
                class="placeholder-img"
                src="./../assets/image/NoImg.png"
                alt=""
              />
            </div>
            <el-carousel
              class="right-ul"
              indicator-position="none"
              v-else
            >
              <el-carousel-item
                v-for="(item, index) in secondContentSrc2"
                :key="index"
              >
                <div class="completed-grid" >
                  <div
                    v-for="(i, key) in item"
                    :key="key"
                    :class="['grid-item', item.length <= 2 ? 'grid-2' : 'grid-3']"
                  >
                    <template v-if="i.photoUrl.includes('.mp4')">
                      <div class="video-badge">
                        视频
                      </div>
                      <video
                        :src="i.photoUrl"
                        controls
                        class="video-item"
                      ></video>
                    </template>
                    <template v-else>
                      <el-image
                        class="img"
                        fit="contain"
                        :src="i.photoUrl"
                        :preview-src-list="i.photoUrlList"
                      ></el-image>
                    </template>
                    <div class="text">
                      <div class="oneTitle">
                        <i class="el-icon-paperclip"></i>
                        {{ i.title }}:
                      </div>
                      <div class="twoTitle">
                        {{ i.describle }}
                      </div>
                    </div>
                  </div>
                </div>
              </el-carousel-item>
            </el-carousel>
          </div>
      </div>

      <!-- 下：即将超时任务 -->
      <div class="bottom-right" data-title="即将超时任务">
        <div class="jijiangTable">
          <div class="loader2">
            <div class="point"></div>
          </div>
          <el-table
            :data="jijiangList"
            ref="rolltable2"
            @mouseenter.native="stopScroll"
            @mouseleave.native="startScroll"
            :max-height="tableContainerHeight"
          >
            <el-table-column prop="group_name" label="任务名称" min-width="80">
              <template slot-scope="scope">
                <slot>
                  <div class="cell-left">
                    <img
                      src="./../assets/image/sucai4.gif"
                      class="status-gif"
                    />
                    <span>{{ scope.row.group_name }}</span>
                  </div>
                </slot>
              </template>
            </el-table-column>
            <el-table-column
              prop="left_minute"
              label="剩余时间"
            >
              <template slot-scope="scope">
                <slot>
                  <span>{{ scope.row.left_minute }}分</span>
                </slot>
              </template>
            </el-table-column>
            <div
              slot="empty"
              class="empty"
            >
              暂无记录
            </div>
          </el-table>
        </div>
      </div>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
import Echarts from "./echarts";
import { getTaskRecordV2, getTaskDoRate, getTaskRecordByStoreId } from "../api/api";
// 引入混入
import { myMixin } from "../common/common.js";

export default {
  data() {
    return {
      secondContent: [],
      secondContentSrc: [],
      secondContentSrc2: [],
      jijiangList: [], //即将超时列表
      completedPercent: null, //完成率
      completedNum: null, //完成数量
      todpercent: null, //待完成完成率
      todNum: null, //待完成数量
      overtimePercent: null, //超时完成率
      overtimeNum: null, //超时数量
      soon_end_percentage: null, //即将超时完成率
      soon_end_num: null, //即将超时数量
      total_tasks: null, //总任务数
      timer: null,
      tableContainerHeight: 150, //表格容器高度
      total_tasks: null, //总任务数
    };
  },
  mixins: [myMixin],
  computed: {
    searchDay() {
      const dateTimeString = new Date();
      const date = new Date(dateTimeString);
      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      const day = date.getDate();
      const formattedDate = `${year}-${month < 10 ? "0" + month : month}-${
        day < 10 ? "0" + day : day
      }`;
      return formattedDate;
    },
  },
  methods: {
    // 计算表格容器高度
    calculateTableHeight() {
      this.$nextTick(() => {
        const jijiangEl = this.$refs.jijiang;

        if (jijiangEl) {
          const containerHeight = jijiangEl.clientHeight;
          this.tableContainerHeight = containerHeight - 50;
        }
      });
    },
    // 停止滚动
    stopScroll() {
      if (this.$refs.rolltable2) {
        this.$refs.rolltable2.doLayout();
      }
    },
    // 开始滚动
    startScroll() {
      if (this.$refs.rolltable2) {
        this.$refs.rolltable2.doLayout();
      }
    },
    // 获取任务清单列表
    async getTaskRecordV2Date() {
      const res = await getTaskRecordV2({
        store_id: localStorage.getItem("store_id"),
        search_day: this.searchDay,
      });
      const taskList = res.data.data.taskList;

      if (taskList) {
        taskList.forEach((item) => {
          if (item.time && item.time.length >= 6) {
            item.time = item.time.substring(11);
          }
        });

        taskList.forEach((item) => {
          if (item.new_task_status === "soon_end") {
            this.jijiangList.push(item);
          }
        });
      }
    },
    // 获取轮播图数据
    async getTaskRecordByStoreId() {
      const res = await getTaskRecordByStoreId({
        store_id: localStorage.getItem("store_id"),
        search_day: this.searchDay,
      });
      if (res.data.code === 0) {
        this.secondContent = [];
      } else {
        Object.values(res?.data.data)[0]?.task.forEach((item) => {
          this.secondContent.push(item);
          item.arr_photo_url.forEach((photoUrl) => {
            let obj = {
              photoUrl: photoUrl,
              describle: item.describle,
              title: item.assess_item_name,
            };
            this.secondContentSrc.push(obj);

            // 创建一个对象来存储相同describle的photoUrl
            let photoUrlMap = [];

            // 遍历secondContentSrc数组，将相同describle的photoUrl存储到photoUrlMap中
            this.secondContentSrc?.forEach((item) => {
              photoUrlMap.push(item.photoUrl);
            });

            // 往secondContentSrc数组中的每个item添加photoUrlList数组
            this.secondContentSrc.forEach((item) => {
              item.photoUrlList = photoUrlMap;
            });
          });
        });

        // 只保留前9张图片（3张轮播，每张3张）
        // this.secondContentSrc = this.secondContentSrc.slice(0, 9);

        for (let i = 0; i < this.secondContentSrc.length; i += 2) {
          this.secondContentSrc2.push(this.secondContentSrc.slice(i, i + 2));
        }
        console.log(this.secondContentSrc2,'this.secondContentSrc2');
        
      }
    },
    // 获取任务完成率
    async getTaskDoRateData() {
      const res = await getTaskDoRate({
        store_id: localStorage.getItem("store_id"),
      });
      this.completedPercent = res.data.data.day.completion_percentage;
      this.completedNum = res.data.data.day.completed_tasks;
      this.todpercent = res.data.data.day.todo_percentage;
      this.todNum = res.data.data.day.todo_tasks;
      this.overtimePercent = res.data.data.day.overtime_percentage;
      this.overtimeNum = res.data.data.day.overtime_tasks;
      this.soon_end_percentage = res.data.data.day.soon_end_percentage;
      this.soon_end_num = res.data.data.day.soon_end;
      this.total_tasks = res.data.data.day.total_tasks;
    },
  },
  components: {
    Echarts,
  },
  created() {
    this.getTaskRecordV2Date();
    this.getTaskDoRateData();
    this.getTaskRecordByStoreId();
  },
  mounted() {
    this.calculateTableHeight();
    window.addEventListener('resize', this.calculateTableHeight);

    this.timer = setInterval(() => {
      this.jijiangList = [];
      this.secondContent = [];
      this.secondContentSrc = [];
      this.secondContentSrc2 = [];
      this.completedPercent = null;
      this.completedNum = null;
      this.todpercent = null;
      this.todNum = null;
      this.overtimePercent = null;
      this.overtimeNum = null;
      this.soon_end_percentage = null;
      this.soon_end_num = null;
      this.total_tasks = null;

      this.getTaskRecordV2Date();
      this.getTaskDoRateData();
      this.getTaskRecordByStoreId();
    }, 180000);
  },
  beforeDestroy() {
    clearInterval(this.timer);
    window.removeEventListener('resize', this.calculateTableHeight);
  },
};
</script>

<style lang="scss" scoped>
/* === 容器样式 === */
.video-surveillance-container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: rgba(13, 22, 48, 0.8);
  border: 1px solid #102844;
  box-shadow: inset 0 0 20px rgba(0, 161, 255, 0.05);
  position: relative;
  border-radius: 4px;
}

.corner {
  position: absolute;
  width: 15px;
  height: 15px;
  border-style: solid;
  border-color: #378da0;
  pointer-events: none;
}

.top-left {
  top: -1px;
  left: -1px;
  border-width: 2px 0 0 2px;
}

.top-right {
  top: -1px;
  right: -1px;
  border-width: 2px 2px 0 0;
}

.bottom-left {
  bottom: -1px;
  left: -1px;
  border-width: 0 0 2px 2px;
}

.bottom-right {
  bottom: -1px;
  right: -1px;
  border-width: 0 2px 2px 0;
}

.panel-header {
  height: 40px;
  display: flex;
  align-items: center;
  padding-left: 25px;
  background: linear-gradient(
    90deg,
    rgba(0, 161, 255, 0.3) 0%,
    rgba(0, 78, 146, 0.1) 60%,
    rgba(0, 0, 0, 0) 100%
  );
  border-bottom: 1px solid rgba(0, 161, 255, 0.3);
  position: relative;
  flex-shrink: 0;
}

.panel-header::before {
  content: "";
  width: 4px;
  height: 16px;
  background: #00d2ff;
  margin-right: 10px;
  box-shadow: 0 0 8px #00d2ff;
}

.panel-title-text {
  font-size: 1.1rem;
  color: #fff;
  font-weight: bold;
  letter-spacing: 1px;
  text-shadow: 0 0 5px rgba(0, 161, 255, 0.5);
}

.video-header {
  display: flex;
  align-items: center;
  height: 40px;
  flex-shrink: 0;
}

.title-box {
  position: absolute;
  right: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.panel-body {
  flex: 1;
  padding: 5px; /* Reduced padding from 10px to 5px to fit better */
  overflow: hidden;
  position: relative;
}

.task-module {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  padding: 5px;
  gap: 8px;
  box-sizing: border-box;
  overflow: hidden;

  .left {
    width: 35%;
    max-width: 35%;
    display: flex;
    flex-direction: column;
    gap: 8px;
    box-sizing: border-box;

    .columns {
      font-size: 14px;
      width: 100%;
      max-width: 100%;
      position: relative;
      border-radius: 8px;
      padding: 10px 5px 5px 5px;
      border: 1px solid rgba(255, 255, 255, 0.3);
      transition: all 0.3s;
      box-sizing: border-box;
      height: 100%;
    }

    .total {
      display: flex;
      flex-direction: column;
      height: 100%;
      position: relative;
    }

    .echarts-row {
      display: flex;
      justify-content: space-around;
      height: 45%;
      align-items: center;
      width: 100%;
    }

    .echarts-item {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 45%;
    }

    .columns:hover {
      box-shadow: 2px 2px 0 1px rgba(255, 255, 255, 0.5);
    }

    .echarts-scale {
      transform: scale(0.8);
    }
  }

  .right {
    width: 63%;
    max-width: 63%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 8px;
    box-sizing: border-box;
    height: 100%;

    .top-right {
      height: 67%;
      display: flex;
      flex-direction: column;
      position: relative;
      border-radius: 8px;
      border: 1px solid rgba(255, 255, 255, 0.3);
      box-sizing: border-box;
      transition: all 0.3s;
      padding: 5px;

      &:before {
        content: attr(data-title);
        position: absolute;
        top: -10px;
        left: 50%;
        transform: translateX(-50%);
        background-color: #25a6f3;
        color: #fff;
        font-size: 16px;
        font-weight: bold;
        padding: 2px 12px;
        border-radius: 3px;
        clip-path: polygon(0% 0%, 100% 0%, 90% 100%, 10% 100%);
        z-index: 99;
      }

      &:hover {
        box-shadow: 2px 2px 0 1px rgba(255, 255, 255, 0.5);
      }

        .completed-carousel {
          flex: 1;
          height: calc(100% - 40px);
          overflow: hidden;
          display: flex;
          flex-direction: column;
          background-color: rgb(2, 19, 49);
          width: 100%;

          .right-ul {
          width: 100%;
          height: 100%;
          margin: 0 auto;
          }

        .right-ul .el-carousel__item > div > div {
          transition: transform 0.3s ease, box-shadow 0.3s ease;

          &:hover {
            transform: scale(1.02);
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
          }
        }

        .placeholder-img {
          height: 80%;
          width: 100%;
          opacity: 0.5;
        }

        .completed-grid {
          width: 100%;
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          justify-content: space-between;
          height: 100%;
          padding: 10px;
          
        }

        .grid-item {
          height: 240px;
          position: relative;
          border: 1px solid rgba(64, 158, 255, 0.35);
          border-radius: 10px;
          box-shadow: inset 0 0 8px rgba(64, 158, 255, 0.15), 0 2px 12px rgba(0, 0, 0, 0.25);
          padding: 8px;
          margin: 0 2px;
          box-sizing: border-box;
        }
        .grid-2 {
          width: 49%;
          height: 330px;
        }
        .grid-3 {
          width: 32%;
          height: 230px;
        }

        .video-badge {
          width: 40px;
          height: 28px;
          border-radius: 8px;
          background-color: #00a2c8;
          position: absolute;
          text-align: center;
          line-height: 28px;
          color: white;
          left: 10px;
          top: 10px;
          z-index: 9999;
          font-size: 12px;
        }

        .video-item {
          width: 100%;
          height: 100%;
          border-radius: 5px;
          border: 2px solid #00a2c8;
          object-fit: contain;
          object-position: center center;
          background-color: #000;
        }

        .img {
          width: 100%;
          height: 100%;
          border-radius: 5px;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .text {
          width: 99%;
          position: absolute;
          bottom: 10px;
          color: white;
          font-weight: bolder;
          border-radius: 5px;
          background: rgba(0, 0, 0, 0.3);
          padding: 2px;

          .oneTitle {
            text-align: left;
            padding: 3px;
            font-size: 18px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }

          .twoTitle {
            padding: 5px;
            font-size: 15px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 3;
            -webkit-box-orient: vertical;
            line-height: 22px;
            max-height: 50px;
            box-sizing: border-box;
          }
        }
      }
    }

    .bottom-right {
      height: 30%;
      display: flex;
      flex-direction: column;
      overflow: visible;
      position: relative;
      border-radius: 8px;
      border: 1px solid rgba(255, 255, 255, 0.3);
      box-sizing: border-box;
      transition: all 0.3s;
      padding: 5px;

      &:before {
        content: attr(data-title);
        position: absolute;
        top: -10px;
        left: 50%;
        transform: translateX(-50%);
        background-color: #25a6f3;
        color: #fff;
        font-size: 16px;
        font-weight: bold;
        padding: 2px 12px;
        border-radius: 3px;
        clip-path: polygon(0% 0%, 100% 0%, 90% 100%, 10% 100%);
        z-index: 99;
      }

      .loader2 {
        position: absolute;
        right: 2px;
        top: 2px;
        z-index: 10;
      }

      .point {
        position: absolute;
        bottom: -23px;
        right: 30px;
        width: 10px;
        height: 10px;
        background-color: rgb(240, 255, 0);
        border-radius: 25px;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .point::before {
        content: "";
        position: absolute;
        width: 1px;
        height: 1px;
        background-color: rgb(240, 255, 0);
        border-radius: 25px;
        animation: loop2 1s 0s infinite;
      }

      @keyframes loop2 {
        0% {
          background-color: rgb(240, 255, 0);
          width: 8px;
          height: 8px;
        }
        100% {
          background-color: rgba(0, 255, 0, 0);
          width: 40px;
          height: 40px;
        }
      }
    }
  }

  .cell-left {
    display: flex;
    align-items: center;
    justify-content: left;
  }

  .status-gif {
    width: 25px;
    height: 12px;
    margin-right: 6px;
  }

  .empty {
    display: flex;
    align-items: center;
    color: #9ca3af;
    justify-content: center;
    height: 120px;
  }

  .columns:before {
    content: attr(data-title);
    position: absolute;
    top: -10px;
    left: 50%;
    transform: translateX(-50%);
    background-color: #25a6f3;
    color: #fff;
    font-size: 16px;
    font-weight: bold;
    padding: 2px 12px;
    border-radius: 3px;
    clip-path: polygon(0% 0%, 100% 0%, 90% 100%, 10% 100%);
    z-index: 99;
  }
}

::v-deep .el-table .warning-row {
  background: oldlace;
}
::v-deep .el-table__empty-block {
  background-color: transparent;
}
::v-deep .el-table__body-wrapper {
  background-color: rgb(2, 19, 49);
}

::v-deep .el-table .success-row {
  background: #f0f9eb;
}

// 即将超时表格内背景颜色
.jijiangTable ::v-deep .el-table th,
.jijiangTable ::v-deep .el-table tr,
.jijiangTable ::v-deep .el-table td {
  background-color: rgb(2, 19, 49);
  border-bottom: 1px dashed rgba(243, 156, 18, 0.4);
  color: rgb(240, 255, 0);
  text-align: center;
  font-size: 14px;
  font-family: Source Han Sans CN Normal, Source Han Sans CN Normal-Normal;
  font-weight: normal;
  padding: 3px 0 !important;
}

.jijiangTable ::v-deep .el-table__header th {
  font-size: 14px;
  color: rgb(240, 255, 0);
  background: #0a3370;
  font-weight: 700;
  padding: 3px 0;
}

.jijiangTable ::v-deep .el-table {
  width: 98%;
}

// 去掉最下面的那一条线
::v-deep .el-table::before {
  height: 0px;
}
// 修改表头样式-加边框
::v-deep .el-table__header-wrapper {
  border: solid 1px #063570;
  box-sizing: border-box;
}

// 修改高亮当前行颜色
::v-deep .el-table tbody tr:hover > td {
  background: #063570 !important;
}
::v-deep .el-table {
  th.gutter,
  colgroup.gutter {
    width: 3px !important;
  }
}
// 关键css代码
::v-deep .el-table__header colgroup col[name="gutter"] {
  display: table-cell !important;
}
::v-deep .el-table__body {
  width: 100% !important;
}

::v-deep .el-carousel__arrow {
  background-color: rgba(0, 0, 0, 0.5) !important;
}

::v-deep .el-carousel__arrow:hover {
  background-color: rgba(0, 0, 0, 0.7) !important;
}

::v-deep .el-carousel__item {
  display: flex;
  align-items: center;
  justify-content: center;
}

::v-deep .el-carousel__container {
  height: 100%;
}

::v-deep .right-ul {
  height: 100% !important;
}

::v-deep .right-ul .el-carousel__container {
  height: 100% !important;
}

::v-deep .completed-carousel .img .el-image__inner {
  width: 100%;
  height: 100%;
  object-fit: contain;
  object-position: center center;
}
</style>

<style lang="scss">
// 滚动条样式（非 scoped，确保样式穿透）
.task-module .el-table__body-wrapper::-webkit-scrollbar {
  width: 6px !important;
  height: 6px !important;
}

.task-module .el-table__body-wrapper::-webkit-scrollbar-track {
  background: rgba(1, 22, 55, 0.3) !important;
  border-radius: 3px;
}

.task-module .el-table__body-wrapper::-webkit-scrollbar-thumb {
  background: linear-gradient(180deg, #409EFF 0%, #409EFF 100%) !important;
  border-radius: 3px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 0 5px rgba(64, 158, 255, 0.5);
}

.task-module .el-table__body-wrapper::-webkit-scrollbar-thumb:hover {
  background: linear-gradient(180deg, #409EFF 0%, #409EFF 100%) !important;
  box-shadow: 0 0 8px rgba(64, 158, 255, 0.8);
}

// 轮播图容器滚动条样式
.task-module .completed-carousel::-webkit-scrollbar {
  width: 6px !important;
  height: 6px !important;
}

.task-module .completed-carousel::-webkit-scrollbar-track {
  background: rgba(1, 22, 55, 0.3) !important;
  border-radius: 3px;
}

.task-module .completed-carousel::-webkit-scrollbar-thumb {
  background: linear-gradient(180deg, #409EFF 0%, #409EFF 100%) !important;
  border-radius: 3px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 0 5px rgba(64, 158, 255, 0.5);
}

.task-module .completed-carousel::-webkit-scrollbar-thumb:hover {
  background: linear-gradient(180deg, #409EFF 0%, #409EFF 100%) !important;
  box-shadow: 0 0 8px rgba(64, 158, 255, 0.8);
}
</style>
